import { useState } from "react";
import { useTheme } from "styled-components";

import { generateColorItemsWithGradients } from "@lib/logic";
import { Icon } from "@atoms";

const BAR_HEIGHT = 3;
const BAR_GAP = 3;

/** A column of small bars running from hot to cold, or open to closed, filling the height next to the options. */
export const GradientBar = ({ type }: { type: "temperature" | "blinds" }) => {
  const theme = useTheme();
  const [height, setHeight] = useState(0);

  const barCount = Math.floor(height / (BAR_HEIGHT + BAR_GAP));
  const colors = generateColorItemsWithGradients(
    barCount,
    type === "temperature" ? theme.gradientBars.temperature.colors : theme.gradientBars.blinds.colors,
  );

  const measureHeight = (bars: HTMLDivElement) => {
    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry?.contentRect.height ?? 0);
    });

    observer.observe(bars);

    return () => {
      observer.disconnect();
    };
  };

  return (
    <div className="mr-[3px] flex flex-col items-center gap-2">
      <Icon
        icon={type === "temperature" ? "temperatureHot" : "sunOpen"}
        size="18px"
      />
      <div
        ref={measureHeight}
        className="flex flex-1 flex-col justify-center gap-[3px]">
        {colors.map((color, index) => (
          <span
            key={index}
            className="h-[3px] w-4 rounded"
            style={{ background: color }}
          />
        ))}
      </div>

      <Icon
        icon={type === "temperature" ? "temperatureCold" : "sunClosed"}
        size="18px"
      />
    </div>
  );
};
